import {Box, Tab, Tabs} from '@customink/pigment-react';
import {styled} from '@customink/pigment-react/lib/themeCustomink';
import React, {useState} from 'react';
import DeliveryOptionsTab from './DeliveryOptionsTab';
import ProductDescriptionTab from './ProductDescriptionTab';
import ProductDetailsTab from './ProductDetailsTab';

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#1e39d2',
    height: '2px'
  },
  width: '100%'
});

const StyledTab = styled(Tab)({
  '&.Mui-selected': {
    color: '#1e39d2'
  },
  color: 'rgba(0,0,0,0.86)',
  fontSize: '1.125rem',
  fontWeight: 600,
  lineHeight: '1.25rem',
  maxWidth: '11.25rem',
  minHeight: '3rem',
  padding: '0.5rem 1rem',
  textTransform: 'none'
});

const TabPanel = styled(Box)({
  minHeight: '25rem',
  padding: '4.5rem 0',
  width: '100%'
});

const ProductTabRenderer = ({activeTab}) => {
  switch (activeTab) {
    case 0:
      return <ProductDescriptionTab />;
    case 1:
      return <ProductDetailsTab />;
    case 2:
      return <DeliveryOptionsTab />;
    default:
      return null;
  }
};

const TabbedProductDetails = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: {lg: '63rem', xl: '80.25rem'},
        overflowY: 'auto',
        padding: {md: '0 1rem', sm: '0 0.5rem'},
        width: '100%'
      }}>
      <Box sx={{width: '100%'}}>
        <Box sx={{borderBottom: 1, borderColor: '#E3E3E3', width: '100%'}}>
          <StyledTabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="product details tabs">
            <StyledTab label="Description" />
            <StyledTab label="Product Details" />
            <StyledTab label="Delivery Options" />
          </StyledTabs>
        </Box>
      </Box>
      <TabPanel>
        <ProductTabRenderer activeTab={activeTab} />
      </TabPanel>
    </Box>
  );
};

export default TabbedProductDetails;
